const {registerModule} = window;

class Agenda {
  constructor(element) {
    this.element = element;
    this.initialize();
  }

  initialize() {
    this.bindUI();
    this.setVars();

    this.revealSelectedDay();
    this.addListeners();
  }

  addListeners() {
    for (let i = 0; i < this.ui.$agendaDays.length; i++) {
      const agendaDay = this.ui.$agendaDays[i];
      agendaDay.addEventListener('click', function() {
        const params = new URLSearchParams(location.search);
        params.set('day', i + 1);
        location.search = params;
      });
      agendaDay.addEventListener('keydown', function(e) {
        const key = e.which || e.keyCode;
        if ([13, 32].includes(key)) {
          e.preventDefault();
          const params = new URLSearchParams(location.search);
          params.set('day', i + 1);
          location.search = params;
        }
      });
    }
  }

  revealSelectedDay() {
    let daySelected = false;

    for (let i = 0; i < this.ui.$agendaTables.length; i++) {
      const agendaTable = this.ui.$agendaTables[i];
      if (i + 1 == this.currentDay) {
        agendaTable.removeAttribute('hidden');
        this.ui.$agendaDays[i].classList.add('agenda__day--active');
        daySelected = true;
      }
    }

    if (!daySelected) {
      this.ui.$agendaTables[0].removeAttribute('hidden');
      this.ui.$agendaDays[0].classList.add('agenda__day--active');
    }
  }

  bindUI() {
    this.ui = {};
    this.ui.$agendaTables = this.element.querySelectorAll('.agenda__table');
    this.ui.$agendaDays = this.element.querySelectorAll('.agenda__day');
  }


  setVars() {
    this.defaultDay = this.ui.$agendaTables[0].dataset.agendaDay;
    this.currentDay;

    const params = new URLSearchParams(location.search);
    if (params.has('day')) {
      this.currentDay = params.get('day');
    }
  }
}

registerModule('Agenda', Agenda);
